export const isObscuredCPF = (value: string) =>
  value
    .toString()
    .match(/[0-9*]/g)
    ?.join('').length === 11;
